<template>
  <UnauthorizedStyled>
    {{ $t('messages.unauthorized') }}
  </UnauthorizedStyled>
</template>

<script>
import { styled } from '@egoist/vue-emotion'
import { flexCenter } from '@styles/mixins'
import chroma from 'chroma-js'

const UnauthorizedStyled = styled('div')`
  ${flexCenter}
  height: 100%;
  font-size: 1.5rem;
  background: ${p => chroma(p.theme.colors.black).alpha(0.5).css()};
  backdrop-filter: blur(7px);
`

export default {
  components: {
    UnauthorizedStyled,
  },
}
</script>
